import React, { memo } from "react";
import { Controller } from "react-hook-form";
import RequiredTitle from "./RequiredTitle";

const GroupTextField = ({ input, control, error }) => {
  const {
    name,
    type,
    label,
    validation,
    alignment = {},
    defaultValues,
    count = 1,
    ...rest
  } = input;

  const { sm = 12, md = 12, lg = 12 } = alignment;

  return (
    <div className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}>
      <RequiredTitle
        label={label}
        validation={validation}
      />

      {Array.from({ length: count }, (_, idx) => (
        <div key={`${name}_${idx}`} className={`col-12 mb-2`}>
          <Controller
            name={`${name}.${idx}`}
            control={control}
            rules={validation}
            defaultValue={defaultValues}
            render={({ field }) => (
              <>
                <input
                  id={`${name}.${idx}`}
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...field}
                  {...rest}
                  onChange={(e) => {
                    const onlyNumbers = e.target.value.replace(/\D/g, "");
                    field.onChange(onlyNumbers);
                  }}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      (event) => event.preventDefault(),
                      { passive: false }
                    )
                  }
                  onBlur={(e) =>
                    e.target.removeEventListener("wheel", (event) =>
                      event.preventDefault()
                    )
                  }
                  className={`form-control ${error ? "is-invalid" : ""}`}
                />
                {error && <div className="invalid-feedback">{error}</div>}
              </>
            )}
          />
        </div>
      ))}
    </div>
  );
};

export default memo(GroupTextField);
